import ListMap from '../core/ListMap';
import Relationship from './Relationship';
import {findConnection} from "../libs";

class RelationshipList extends ListMap {
  constructor(args = {}) {
    const {
      data = {},
    } = args;

    const relationshipList = Object.entries(data).map((v) => {
      if (!v[1]) return; // If relationship is undefined then jump out

      return new Relationship({
        ...args,
        data: {
          name: v[0],
          links: v[1] ? v[1].links : null,
          etag: v[1] ? v[1].etag : null,
          data: v[1] ? v[1].data : null,
          meta: v[1] ? v[1].meta : null,
        },
      });
    }).filter(v => !!v); // Filter out undefined relationships.

    super({ ...args, data: relationshipList });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new Relationship({ data: { name: key } });
  }

  connection() {
    return findConnection(this.parent());
  }

  export() {
    const relationships = {};
    this.itemList.forEach((v) => {
      relationships[v.attr('name')] = v.export();
    });

    return relationships;
  }
}

export default RelationshipList;
